module.exports = __webpack_public_path__ + "img/sign-15.43e6586c.jpg";